// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3tyaP","detailsBorder":"styles_detailsBorder__1DdRp"};